
import TimeCountdown from '@/components/TimeCountdown'
// import QRCode from 'qrcodejs2';
export default {
    components: {
        TimeCountdown
    },
    props: {
        amount: {
            type: Number,
            required: true
        },
        payId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            qrError: false,
            qrCodeLoading: false,
            submitLoading: false,
            timers: null,
            pollingTime: null,
            payInfo: {
                rechargeOrderNo: null,
                orderOutTime: null,
                amount: null
            },
            crateQrcode: ''
        }
    },
    methods: {
        countDowmEnd() {
            this.closeDialogVisible()
            this.qrError = true
        },
        debounce(fn, wait = 300) {
            let timer
            return function () {
                let _this = this
                let args = arguments
                if (timer) {
                    clearTimeout(timer)
                }
                timer = setTimeout(function () {
                    fn.apply(_this, args)
                }, wait)
            }
        },
        getQrCode() {
            this.closeDialogVisible()
            let _this = this
            this.debounce(_this.getPayqrCodeUrl())
        },
        // 重新获取二维码
        getPayqrCodeUrl() {
            let data = {
                action: {
                    id: this.payId, // 支付砍价id
                    payScene: 'QR_CODE', // 支付场景
                    payType: 'ALIPAY' // 支付方式
                }
            }
            this.qrCodeLoading = true
            this.$api
                .bargainPay(data)
                .then((res) => {
                    this.qrError = false
                    if (res.success) {
                        this.timers = new Date().getTime()
                        this.qrCodeLoading = false
                        this.$nextTick(() => {
                            // this.$refs.qrcodePay.innerHTML = ''
                            this.crateQrcode = res.data.qrCodeUrl
                        })
                        this.payInfo = {
                            rechargeOrderNo: res.data.rechargeOrderNo,
                            amount: res.data.amount,
                            orderOutTime: res.data.orderOutTime
                        }
                        this.getPayOrderPayStatus(res.data.rechargeOrderNo)
                        // 启动轮询
                        this.pollingTime = setInterval(() => {
                            this.getPayOrderPayStatus(res.data.rechargeOrderNo)
                        }, 3000)
                    } else {
                        this.$emit('paySuccess', false, res.info)
                    }
                })
                .catch(() => {
                    this.qrCodeLoading = false
                })
        },
        // 获取充值订单支付状态
        getPayOrderPayStatus(rechargeOrderNo) {
            let _this = this
            let params = {
                action: {
                    rechargeOrderNo: rechargeOrderNo
                }
            }
            this.$api.queryBargainOrder(params).then((res) => {
                if (res.success) {
                    let data = res.data
                    if (data.payStatus === 'PAY_SUCCESS') {
                        clearInterval(_this.pollingTime) // 清除定时器
                        this.$emit('paySuccess', 'PAY_SUCCESS')
                        return
                    }
                    if (data.payStatus === 'PAY_CLOSE') {
                        clearInterval(_this.pollingTime) // 清除定时器
                        this.$emit('paySuccess', 'PAY_CLOSE')
                        return
                    }
                    if (data.payStatus !== 'PAYING') this.$message.error(res.info)
                }
            })
        },
        // 创建二维码
        // crateQrcode(qrCodeUrl) {
        //     new QRCode('qrcodePay', {
        //         width: 150,
        //         height: 150, // 高度
        //         text: qrCodeUrl, // 二维码内容
        //     })
        // },
        closeDialogVisible() {
            let _this = this
            // this.fullscreenLoading = false;
            clearInterval(_this.pollingTime)
        }
    }
}
